import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../Interceptor/interceptor";

export const productsDetailsApi = createApi({
    reducerPath: "productsDetailsApi",
    baseQuery: baseApiQuery,
    tagTypes: ['productsDetails'],
    endpoints: (builder) => ({
        getProductDetails: builder.query<any, any>({
            query: ({ scannedCode }) => {
                const url = `product/prices/${scannedCode}/fetch/`;
                return {
                    url: url,
                    method: 'GET',
                };
            },
            providesTags: ['productsDetails']
        }),
    })
});

export const { useGetProductDetailsQuery } = productsDetailsApi;